"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardAwareScrollView = void 0;
const react_native_1 = require("react-native");
exports.KeyboardAwareScrollView = react_native_1.Platform.OS === 'web'
    ? react_native_1.ScrollView
    : require('react-native-keyboard-aware-scroll-view')
        .KeyboardAwareScrollView;
